import React from 'react';

const TrashAltIcon = () => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 3.19775V1.69775C4.5 1.14547 4.94772 0.697754 5.5 0.697754H9.5C10.0523 0.697754 10.5 1.14547 10.5 1.69775V3.19775M0 3.69775H15M1.5 3.69775V13.6978C1.5 14.25 1.94772 14.6978 2.5 14.6978H12.5C13.0523 14.6978 13.5 14.25 13.5 13.6978V3.69775M7.5 7.19775V12.1978M4.5 9.19775V12.1978M10.5 9.19775V12.1978"
        stroke="#7E8A96"
      />
    </svg>
  );
};

export default TrashAltIcon;
